/*
 * View for the user configuration screen
 */

define(["marionette", "./template/userAdminTemplate.html"], function (Marionette, UserTemplate) {
  "use strict";

  const UserView = {};

  UserView.userView = Marionette.Layout.extend({
    className: "max-height",
    template: UserTemplate,
    regions: {
      adminArea: ".adminMainArea",
    },
    triggers: {
      "click #generalConfig": "show:generalConfig",
      "click #kbConfig": "show:kbConfig",
      "click #notifications": "show:notifications",
      "click #changePassword": "change:password",
      "click #refreshTokens": "show:refreshTokens",
    },
  });

  return UserView;
});
